import { createSelector } from 'reselect'
import sessionTypes from 'helpers/enums/sessionTypes'
import userRoles from 'helpers/enums/userRoles'
import featureFlagsTypes from 'helpers/enums/featureFlagsTypes'
import getActivitySelector from './interactive_video_participant_activity_selector'
import featureFlagsSelectorCreator from 'redux/selectors/feature_flags/feature_flags_selector'

const featureFlagsSelector = featureFlagsSelectorCreator([
	featureFlagsTypes.INTERACTIVE_VIDEO_PREVENT_SKIPPING_VIDEOS,
])

const getInteractiveVideoSession = state => state.interactiveVideo

export default createSelector(
	[
		getInteractiveVideoSession,
		getActivitySelector,
		featureFlagsSelector,
	],
	(interactiveVideo, activity, featureFlags) => {
		const participantUid = interactiveVideo.participantUid
		let shouldPreventSkippingVideos = false
		let maximumTime = 0
		if (
			featureFlags[featureFlagsTypes.INTERACTIVE_VIDEO_PREVENT_SKIPPING_VIDEOS]
			&& participantUid !== ''
			&& interactiveVideo.isSubmissionRequiredEnabled
			&& interactiveVideo.sessionType === sessionTypes.HOMEWORK
			&& interactiveVideo.role === userRoles.STUDENT
		) {
			shouldPreventSkippingVideos = true
			const participant = interactiveVideo.participants.find(
				participant => participant.uid === participantUid
			)
			maximumTime = participant && interactiveVideo.participantState.maximumTimeReached || 0
		}
		return {
			shouldPreventSkippingVideos,
			maximumTime,
		}
	}
)
